import { breakpoints } from '@bnnvara/breakpoints';
import { ThemeIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Theme';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { typography, space } from 'styled-system';

const getColor = (theme, themeSlug) => {
  const color = theme.themes[themeSlug.replace('-', '_')]?.main;

  if (color) return color;
  return theme.base.white;
};

const StyledThemeTagCard = styled.span`
  display: inline-flex;
  align-items: center;
  text-transform: 'uppercase'};
  color: ${({ theme, themeSlug }) => getColor(theme, themeSlug)};
  font-size: 10px;
  font-weight: 700;
  line-height: 10px;

  ${breakpoints.md} {
    padding: 4px 0px;
    border-radius: 2px;
    color: ${({ theme }) => theme.base.white};
    font-size: 12px;
    font-weight: 700;
    line-height: '12px';
  }

  svg {
    height: 9px;
    width: 9px;
    padding-right: 4px;
    * {
      fill: ${({ theme, themeSlug }) => getColor(theme, themeSlug)};
    }
    ${breakpoints.md} {
      height: 12px;
      width: 12px;
    }
  }

  ${space}
  ${typography}
  text-transform: ${({ textTransform }) => textTransform};
`;

export const ThemeTagCard = ({
  children,
  themeSlug,
  textTransform,
  ...props
}) => {
  return (
    <StyledThemeTagCard
      themeSlug={themeSlug}
      textTransform={textTransform}
      {...props}
    >
      <ThemeIcon />
      {children}
    </StyledThemeTagCard>
  );
};

ThemeTagCard.defaultProps = {
  textTransform: 'inherit',
};

ThemeTagCard.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.node,
  themeSlug: PropTypes.string,
  textTransform: PropTypes.string,
};
